import { Grid } from '@mantine/core';
import { useParams } from 'react-router';
import HeaderStatistic from '../HeaderStatistic';
import LazyLoadSpinner from '../LazyLoaderSpinner';

const WhatsappMessagesStats = ({ whatsappMessage, stats, period, currency }) => {
  const { accountId, domainId } = useParams();

  const segmentLink = (preset) => {
    return `#/accounts/${accountId}/domains/${domainId}/segments/new?preset=${preset}&id=${whatsappMessage.id}&startDate=${period.startDate}&endDate=${period.endDate}`;
  };

  if (!stats) {
    return (
      <Grid.Col span={12}>
        <Grid justify="center">
          <LazyLoadSpinner />
        </Grid>
      </Grid.Col>
    );
  } else {
    return (
      <>
        <Grid.Col span={12}>
          <Grid>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Sent"
                stats={stats}
                stat="sent"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageSend')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Delivered"
                stats={stats}
                stat="deliveries"
                percentageOfStat="sent"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageDelivery')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Opened"
                stats={stats}
                stat="opened"
                percentageOfStat="deliveries"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageOpen')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Clicks"
                stats={stats}
                stat="clicks"
                percentageOfStat="deliveries"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageClicks')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Conversions"
                stats={stats}
                stat="conversions"
                percentageOfStat="clicks"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageConversion')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Purchases"
                stats={stats}
                stat="purchases"
                percentageOfStat="conversions"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessagePurchase')}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center">
              <HeaderStatistic
                title="Revenue"
                stats={stats}
                stat="purchases"
                id={whatsappMessage.id}
                statKey="value"
                currency={currency}
              />
            </Grid.Col>
            <Grid.Col span="auto" ta="center" style={{ borderLeft: '1px dotted' }}>
              <HeaderStatistic
                title="Bounces"
                stats={stats}
                stat="bounces"
                percentageOfStat="sent"
                id={whatsappMessage.id}
                statKey="count"
                link={segmentLink('whatsappMessageBounce')}
              />
            </Grid.Col>
          </Grid>
        </Grid.Col>
      </>
    );
  }
};
export default WhatsappMessagesStats;
